import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Brand } from 'src/typings';
import { ProviderPriceService } from '../provider-price.service';

@Component({
  selector: 'app-upload-brand-result-item',
  templateUrl: './upload-brand-result-item.component.html',
  styleUrls: ['./upload-brand-result-item.component.scss']
})
export class UploadBrandResultItemComponent {
  @Input() brand?: string;

  control: FormControl<Brand | undefined> = new FormControl();

  constructor(private providerPriceService: ProviderPriceService) {}
}
